module.exports = __webpack_public_path__ + "static/media/home_bg.99e8d1a1.jpg";